import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Container = styled.div`
  display: grid;
  grid-gap: 2rem;

  ${breakpoint("tablet")`
    grid-template-columns: 1fr 1fr;
  `}

  ${breakpoint("desktop")`
    grid-template-columns: 1fr 1fr 1fr;
  `}

  ${breakpoint("mahoosive")`
    grid-template-columns: 1fr 1fr 1fr 1fr;
  `}
`
